// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__21pOO","on":"Nav_on__92FVh"};